module.exports = __webpack_public_path__ + "static/Icons_ReverseMortgage_inactive-f76d4b4d9ba8aa69b3bb233b008a7250.png";